import { ValueFunction } from '../../index';

function methodPlusX({x = null, constant = 0}) {
  if (x !== null) {
    return x + constant;
  } else {
    return null;
  }
}

export const plusX = new ValueFunction(
  methodPlusX,
  {
    label: 'Add a Constant to the Series',
    description: 'x + constant',
    parameters: [
      {'name': 'x', 'type': 'number'},
      {'name': 'constant', 'type': 'number', 'default': 0}
    ],
    maxLength: 1
  }
);